<template>
  <div>
      <div class="application-login-part">
        <v-col class="login-col" cols="12" sm="12">
              <div id="signin" v-if = "resetPassword == 0">
              <div class="signin-form">
                <div>
                  <form @submit.prevent="onSubmit" >
                    <div class="input">
                      <label for="email">Login</label>
                      <input
                              type="email"
                              id="email"
                              v-model="email">
                    </div>
                    <div class="input">
                      <label for="password">Password</label>
                      <input  
                              type="password"
                              id="password"
                              v-model="password">
                    </div>
                    <v-layout justify-end>
                        <v-chip small class="chip-action-box" @click="resetPassword = 1">Forgotten password...</v-chip>
                    </v-layout>
                    <div>
                      <v-btn type="submit" class="btn-style btn-primary">Login</v-btn>
                    </div>
                  </form>
                </div>    
                <LoginIllustration class="login-illustration"/>
                <p class="auth-link">Don't have an account? <span class="signup-btn" @click="register()">Sign up</span></p> 
              </div>
            </div>
            <div v-if="resetPassword == 1">
              <ChangePassword v-bind:source="1" v-bind:eml="''"/>
            </div>
        </v-col>
      </div>

      <div class="highlighted-application-features" align="center" justify="center">
          <br>
<!--           <h1>PRogressIve System <br/>for interaCtIve (programming) Learning <br/>and Learning Assistance</h1>
          <h2><br/></h2>
 -->

            <v-col class="highlighted-application-features__item" cols="12" xs="12" sm="12" md="5">
              <img src="@/assets/img/login_img/learn-and-teach.svg" alt="">
              <div class="highlighted-application-features__description">
                <h3>Learn and teach...</h3>
                <p></p>
                <p>...programming</p>
              </div>
            </v-col>

            <v-col class="highlighted-application-features__item" cols="12" xs="12" sm="12" md="5">
              <img src="@/assets/img/login_img/master-current-language.svg" alt="">
              <div class="highlighted-application-features__description">
                <h3>Master...</h3>
                <p></p>
                <p>...your current language</p>
              </div>
            </v-col>

            <v-col class="highlighted-application-features__item" cols="12" xs="12" sm="12" md="5">
              <img src="@/assets/img/login_img/coding-practice.svg" alt="">
              <div class="highlighted-application-features__description">
                <h3>Practice...</h3>
                <p></p>
                <p>...coding</p>
              </div>
            </v-col>

            <v-col class="highlighted-application-features__item" cols="12" xs="12" sm="12" md="5">
              <img src="@/assets/img/login_img/training-with-others.svg" alt="">
              <div class="highlighted-application-features__description">
                <h3>Improve your skills...</h3>
                <p></p>
                <p>...by training with others</p>
              </div>
            </v-col>

            <v-col class="highlighted-application-features__item" cols="12" xs="12" sm="12" md="5">
              <img src="@/assets/img/login_img/coding-skills-building.svg" alt="">
              <div class="highlighted-application-features__description">
                <h3>Become...</h3>
                <p></p>
                <p>...an expert</p>
              </div>
            </v-col>

            <v-col class="highlighted-application-features__item" cols="12" xs="12" sm="12" md="5">
              <img src="@/assets/img/login_img/train-or-fight.svg" alt="">
              <div class="highlighted-application-features__description">
                <h3>Compete, fight...</h3>
                <p></p>
                <p>...and play</p>
              </div>
          </v-col>

    </div>   
  </div>
</template>


<script>
import ChangePassword from '../../components/misc/ChangePassword.vue'
import configData from '../../config.js'

import LoginIllustration from './login_illustration.vue'

  export default {
    data: function () {
      return {
        email: '',
        password: '',
        resetPassword: 0,
        grant_type:"password",
        client_id: "2",        
        loader: false,
        infoError: false,
        userLang : 'xx'
      }      
    },
    mounted() {
      this.$store.commit('setFeedback', null) 
      this.userLang = navigator.language || navigator.userLanguage;
      /* eslint-disable no-console */
      // console.log ("The language is: " + this.userLang);
    },
    components: {
      ChangePassword,
      LoginIllustration
    },
    methods: {
      onSubmit () {
        const formData = {
            email: this.email,
            password: this.password,
            grant_type: this.grant_type,
            client_id: this.client_id,
            client_secret: configData.client_secret,
            username: this.email,
        }
        this.$store.dispatch('login', formData)
      },
      register() { 
        if (this.$router.currentRoute.name != 'register')
                    this.$router.push({name:'register', params: {}})  
      },
    }
  }

</script>

<style>
</style>